import { createContext, useContext, useState } from 'react';

const MenuContext = createContext();

export const MenuProvider = ({ children }) => {
    const [selectedMenuItem, setSelectedMenuItem] = useState(null);

    const selectMenuItem = (menuItem) => {
        setSelectedMenuItem(menuItem);
    };

    return (
        <MenuContext.Provider value={{ selectedMenuItem, selectMenuItem }}>
            {children}
        </MenuContext.Provider>
    );
};

export const useMenuContext = () => {
    const context = useContext(MenuContext);
    if (!context) {
        throw new Error('useMenuContext must be used within a MenuProvider');
    }
    return context;
};
